import axios from 'axios';
import Auth from './auth';
import { API_ROOT } from './apiConfig';

export default class TxCrossmapDataAccess {

    getSystems() {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "GetEOMSystems"
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('SystemList', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    console.log("here fail");
                });
        });
    }

    getClientsBySystem(systemId) {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "GetFacilityBySystemId", parameters: { systemId: systemId }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('txCrossClientList', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    getCollectors() {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_RCM_Collectors", parameters: { }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('collectorsList', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    getStatusCodes() {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_RCM_StatusCodes", parameters: {}
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('statusCodesList', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    getFinancialClass(system,facilityId) {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_RCMBO_FC", parameters: { FID: facilityId, SystemID: system }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('statusCodesList', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    getFilteredData(pas, fid) {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_RCMBO_CollectorConditions", parameters: { FID: fid }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    processCollectors(rows,userName) {
        const auth = new Auth();

        const rowsToSend = rows.map(r => ({
            ...r,
            finClass: Array.isArray(r.finClass) ? r.finClass.join(',') : (r.finClass ?? ''),
            type: Array.isArray(r.type) ? r.type.join(',') : (r.type ?? ''),
            statusCode: Array.isArray(r.statusCode) ? r.statusCode.join(',') : (r.statusCode ?? ''),
            patientName: `${r.patientNameStart ?? ''}${r.patientNameStart && r.patientNameEnd ? '-' : ''}${r.patientNameEnd ?? ''}`,
            dos: r.type?.includes('DOS') ? r.dos : null
        }));

        console.log(rowsToSend, userName);

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_Collector_Process", parameters: { rows: JSON.stringify(rowsToSend), username: userName  }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

}